import script from "./MyOrderClosedHeader.vue?vue&type=script&setup=true&lang=ts"
export * from "./MyOrderClosedHeader.vue?vue&type=script&setup=true&lang=ts"

import "./MyOrderClosedHeader.vue?vue&type=style&index=0&id=078eb536&scoped=true&lang=css"

import exportComponent from "/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-078eb536"]])

export default __exports__